import script from "./OpalModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./OpalModal.vue?vue&type=script&setup=true&lang=ts"

import "@/styles/modal/xmodal-changes.css?vue&type=style&index=0&id=8696fe6c&scoped=true&lang=css"
import "./OpalModal.vue?vue&type=style&index=1&id=8696fe6c&scoped=true&lang=css"
import "@/styles/button/loading.css?vue&type=style&index=2&id=8696fe6c&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\src\\ApplicantPortal.Web\\clientapp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8696fe6c"]])

export default __exports__